import api from './api';

const endpoint = '/api/reset-token';

const ResetTokenService = {

    // Solicita reset (email)
    solicitar: async (email) => {
        const response = await api.post(
            `${endpoint}/solicitar`,
            null,
            { params: { email } }
        );
        return response.data;
    },

    // Valida token (link da URL)
    validar: async (token) => {
        const response = await api.get(
            `${endpoint}/validar`,
            { params: { token } }
        );
        return response.data;
    },
    // redefinir senha
    redefinir: async (dados) => {
        const response = await api.post(
            `${endpoint}/redefinir`,
            dados
        );
        return response.data;
    },
    // Consome token após redefinir senha
    consumir: async (token) => {
        const response = await api.post(
            `${endpoint}/consumir`,
            null,
            { params: { token } }
        );
        return response.data;
    }
};

export default ResetTokenService;
